import React from 'react'
import intl from 'react-intl-universal'
import { connect } from 'react-redux'
import { verifyMfaCode, resendMfaCode, cancelMfa } from '../actions/AuthActions'

const NON_DIGITS = /\D/g
const DEFAULT_CODE_LENGTH = 6

const mapStateToProps = state => ({
  mfa: state.auth.mfa
})

const mapDispatchToProps = dispatch => ({
  verifyAction: (mfa_token, code) => dispatch(verifyMfaCode(mfa_token, code)),
  resendAction: (mfa_token) => dispatch(resendMfaCode(mfa_token)),
  cancelAction: () => dispatch(cancelMfa())
})

class MfaFormComponent extends React.Component {
  constructor() {
    super()
    this.state = {
      code: ''
    }
  }

  handleChange = (event) => {
    // The code is digits only - drop anything else instead of failing server side.
    this.setState({
      code: event.target.value.replace(NON_DIGITS, '')
    })
  }

  handleSubmit = (event) => {
    const {mfa, verifyAction} = this.props
    const {code} = this.state
    event.preventDefault()
    if (!code) return
    verifyAction(mfa.mfa_token, code)
  }

  handleResend = () => {
    const {mfa, resendAction} = this.props
    resendAction(mfa.mfa_token)
  }

  render() {
    const {mfa, cancelAction} = this.props
    const {code} = this.state
    return (
      <div className="center_wrapper">
        <div className="login_form mfa_form">
          <form onSubmit={this.handleSubmit}>
            <h2>{intl.get('Weryfikacja dwuetapowa')}</h2>
            <p className="mfa-hint">
              {intl.get('Kod weryfikacyjny wysłaliśmy na adres')} {mfa.mfa_email_hint}
            </p>
            <div className="field">
              <input
                placeholder=" "
                name="code"
                id="f-mfa-code"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                autoComplete="one-time-code"
                autoFocus
                maxLength={mfa.mfa_code_length || DEFAULT_CODE_LENGTH}
                value={code}
                onChange={this.handleChange} />
              <label htmlFor="f-mfa-code">{intl.get('Kod weryfikacyjny')}</label>
            </div>
            <input type="submit" value={intl.get('Potwierdź')} disabled={!code} />
            { mfa.error &&
              <div className="login-failed">{mfa.error}</div>
            }
            { mfa.info &&
              <div className="login-info">{mfa.info}</div>
            }
            <div className="mfa-actions">
              <button type="button" onClick={this.handleResend}>
                {intl.get('Wyślij nowy kod')}
              </button>
              <button type="button" onClick={cancelAction}>
                {intl.get('Wróć do logowania')}
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

const MfaForm = connect(mapStateToProps, mapDispatchToProps)(MfaFormComponent)
export default MfaForm
